import {SHOP_CONSTANT,StorageHelpers} from "../routes/shop/merchant/merchantHelper"
import alertMixin from 'shared/mixins/alertMixin';
import orderApi from "../api/orderApi"

export const globalShopMixins = {
    mixins:[alertMixin],
    mounted(){
        console.log("globalShopMixins mounted");
        bus.$on(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED, (data) => {
            this.orderQUeueUpdateHandler(data);
            // this.orderStatusUpdateHandler(data);
        });
        bus.$on(SHOP_CONSTANT.EVENTS.ORDER_STATUS_UPDATED, (data) => {
            this.orderStatusUpdateHandler(data);
        });
        this.syncOrderStatus();
    },
    computed: {
        accountId() {
            return this.$route.params.accountId;
        },
        isRedirectAndNotPaymentSuccess(){
            if (this.$route.query?.status && this.$route.query?.status !== "succeeded") {
                return true;
            }
            return false;
        },
    },
    watch:{
        '$route.params.accountId'(newValue,oldValue){
            this.syncOrderStatus();
        },
    },
    methods:{
        async orderQUeueUpdateHandler(completedOrder){
            const {ORDER_STATUS} = SHOP_CONSTANT;
            const accountId = this.$route.params.accountId;
            // console.log({completedOrder},this.$route.query);
            // no need to update if query has status cancel from payment redirect
            if (this.isRedirectAndNotPaymentSuccess) {
                // payment redirect
                return
            }
            // handle if order is completed
            if (completedOrder.order_status === ORDER_STATUS.COMPLETED) {
                console.log("deleting order =",completedOrder.id);
                const {isDeleted} = StorageHelpers.deleteCartByAccountIdAndOrderId(completedOrder.account_id,completedOrder.id);
                if (isDeleted) {
                    this.showAlert("Your order is completed");

                    // do in vuex store
                    await this.$store.dispatch("carts/deleteCartByAccountIdAndOrderId",{
                        accountId: this.$route.params.accountId,
                        order_id: completedOrder.id,
                    })

                    // Check the current route
                    const currentRoute = this.$route.path;
                    // If the user is on "/app/accounts/4/payment", navigate to "/app/accounts/4/order"
                    if (currentRoute === `/app/accounts/${completedOrder.account_id}/payment`) {
                        this.$router.push(`/app/accounts/${completedOrder.account_id}`);
                    }
                }
            }
            // handle if order is cancelled
            if (completedOrder.order_status === ORDER_STATUS.CANCELED) {
                console.log("deleting order =",completedOrder.id);
                const {isDeleted} = StorageHelpers.deleteCartByAccountIdAndOrderId(completedOrder.account_id,completedOrder.id);
                if (isDeleted) {
                    this.showAlert("Your order is cancelled");

                    // do in vuex store
                    await this.$store.dispatch("carts/deleteCartByAccountIdAndOrderId",{
                        accountId: this.$route.params.accountId,
                        order_id: completedOrder.id,
                    })

                    // Check the current route
                    const currentRoute = this.$route.path;
                    // If the user is on "/app/accounts/4/payment", navigate to "/app/accounts/4/order"
                    if (currentRoute === `/app/accounts/${completedOrder.account_id}/payment`) {
                        this.$router.push(`/app/accounts/${completedOrder.account_id}`);
                    }
                }
            }
            // after localstorage update, update the vuex store


        },
        // handle order status updated
        orderStatusUpdateHandler(orderData){
            const {PACKED,PAID,DELIVERED,COLLECTED} = SHOP_CONSTANT.ORDER_STATUS;
            console.log({orderData,});
            const myOrder = StorageHelpers.getCartByOrderId(orderData.id);
            if (!myOrder?.summary?.order_id) {
                return
            }
            if (orderData.order_status === PACKED){
                myOrder.summary.delivery = orderData.delivery;
                myOrder.summary.order_status = orderData.order_status;
                console.log({myOrder,fr:"PACKED"});
                StorageHelpers.updateCartById(orderData.account_id,myOrder);
                this.notifyShopMessage('Order Ready for Collection', 'Your order has been packed and is now ready for collection at your convenience.');
                bus.$emit(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,orderData);
            }else if (orderData.order_status === PAID){
                myOrder.summary.delivery = orderData.delivery;
                myOrder.summary.order_status = orderData.order_status;
                console.log({myOrder,fr:"PAID"});
                StorageHelpers.updateCartById(orderData.account_id,myOrder)

            }
            else if (orderData.order_status === DELIVERED){
                myOrder.summary.delivery = orderData.delivery;
                myOrder.summary.order_status = orderData.order_status;
                console.log({myOrder,fr:"DELIVERED"});
                StorageHelpers.updateCartById(orderData.account_id,myOrder)
                this.showAlert('Your order is now out for delivery');
                this.notifyShopMessage('Order Out for Delivery', 'Your order is now out for delivery');
                bus.$emit(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,orderData); // to hide "cancel btn"
            }
            else if (orderData.order_status === COLLECTED){
                myOrder.summary.delivery = orderData.delivery;
                myOrder.summary.order_status = orderData.order_status;
                console.log({myOrder,fr:"COLLECTED"});
                StorageHelpers.updateCartById(orderData.account_id,myOrder)
                this.showAlert('Your have collected your order');
                this.notifyShopMessage('Your have collected your order', 'Your have collected your order');
                bus.$emit(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,orderData); // to hide "cancel btn"
            }
            // if collected
            // triger an event to update the UI in any page
            // bus.$emit(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,orderData);
        },
        async syncOrderStatus(){
            // console.log("1st Query params:", this.$route.query);
            try {
                let cart = StorageHelpers.getCartById(this.accountId);
                // console.log({cart},"Main");
                if (cart?.summary?.contact_id) {
                    //
                    if (this.isRedirectAndNotPaymentSuccess) {
                        // if it has query {status:"canceled"}, then it is from payment redirect. only remove the order_id,createdAt,order_status from local storage summary
                        const newCart = {
                            ...cart,
                        }
                        console.log("New Cart",newCart);
                        delete newCart.summary.order_id;
                        delete newCart.summary.createdAt;
                        delete newCart.summary.order_status;
                        await this.$store.dispatch("carts/updateCartById",{
                            accountId: this.$route.params.accountId,
                            cart: newCart,
                        })
                        // console.log("New Cart after Del",newCart);
                        cart = StorageHelpers.getCartById(this.accountId)
                    }
                    // console.log({cart},"Main Checking");
                    const {data} = await orderApi.getOrdersStatusByContactId(cart?.summary?.contact_id)
                    // console.log({data});
                    if (Array.isArray(data)) {
                        data.forEach(([orderId,status])=>{
                            // update the status
                            if (cart?.summary?.order_id === orderId) {
                                // if status is completed or cancelled, the delete else update
                                const {CANCELED,COMPLETED} = SHOP_CONSTANT.ORDER_STATUS
                                if ((status === COMPLETED) || (status === CANCELED)) {
                                    StorageHelpers.deleteCartByAccountIdAndOrderId(this.accountId,orderId)
                                }else{
                                    cart.summary.order_status = status;
                                    StorageHelpers.updateCartById(this.accountId,cart)
                                }
                            }
                        })
                        // triger an event to update the UI in any page
                        bus.$emit(SHOP_CONSTANT.EVENTS.ORDER_QUEUE_UPDATED,{});
                    }

                }
            } catch (error) {
                console.log(error);
            }
        },
         // show notification and sound notitify
         notifyShopMessage(title, message) {
            try {
                // Notification API
                if ('Notification' in window) {
                    if (Notification.permission === "granted") {
                        new Notification(title, { body: message });
                    } else {
                        Notification.requestPermission().then(permission => {
                            if (permission === "granted") {
                                new Notification(title, { body: message });
                            } else {
                                console.warn("Notification permission denied.");
                            }
                        });
                    }
                } else {
                    console.warn("Notification API not supported in this browser.");
                }

                // Speech API
                if ('speechSynthesis' in window) {
                    const utterance = new SpeechSynthesisUtterance(message);

                    // Define a function to select the voice
                    const setVoice = () => {
                        const voices = window.speechSynthesis.getVoices();
                        const femaleVoice = voices.find(voice => voice.name.toLowerCase().includes('female')) || voices[0];
                        if (femaleVoice) {
                            utterance.voice = femaleVoice;
                        }
                        window.speechSynthesis.speak(utterance);
                        console.log("Speech Synthesis triggered:", message);
                    };

                    // Check if voices are already loaded
                    if (window.speechSynthesis.getVoices().length !== 0) {
                        setVoice();
                    } else {
                        // Wait for the voices to be loaded
                        window.speechSynthesis.onvoiceschanged = setVoice;
                    }
                } else {
                    console.warn("Speech Synthesis API not supported in this browser.");
                }
                /*
                if ('speechSynthesis' in window) {
                    const utterance = new SpeechSynthesisUtterance(message);
                     // Fetch available voices and select a female voice dynamically
                    const voices = window.speechSynthesis.getVoices();
                    const femaleVoice = voices.find(voice => voice.name.toLowerCase().includes('female')) || voices[0];
                    if (femaleVoice) {
                        utterance.voice = femaleVoice;
                    }
                    // speak now
                    window.speechSynthesis.speak(utterance);
                    console.log("Speech Synthesis triggered:", message);
                } else {
                    console.warn("Speech Synthesis API not supported in this browser.");
                }
                */

            } catch (error) {
                console.log(error);
            }
        },

        // end of methods
    },
}